// import React from 'react';
// import { useState, useEffect } from 'react';
// import barChart from '../../../../assets/icons/bar-chart-square-02.png';
// import { Table } from 'antd';
// import './style.css';
// import { useNavigate } from 'react-router-dom';
// import { CaretRightOutlined, CaretDownOutlined, EyeOutlined } from "@ant-design/icons";
// import {
//   Card,
//   Form,
//   Input,
//   Button,
//   Row,
//   Col,
//   Steps,
//   Upload,
//   message,
//   Select,
//   Space,
//   Tooltip,
//   Modal,

// } from 'antd';
// import arrow_down from '../../../../assets/icons/arrow_down.png';
// import chevron_down from '../../../../assets/icons/chevron_down.png';
// import { PlusOutlined, MinusOutlined } from '@ant-design/icons';
// import dashboard_table_icon from '../../../../assets/icons/dashboard_table_icon.png';
// import download_pop_icon from '../../../../assets/icons/download_pop_icon.png';
// import filterIcon from '../../../../assets/icons/filter_icon.png';
// import dashboard_down_icon from '../../../../assets/icons/dashboard_down_icon.png';
// import line from '../../../../assets/icons/line.png';
// import { useSelector, useDispatch } from 'react-redux';
// import CircularProgressBar from '../circularProgressBar';
// import dashboardCircle from '../../../../assets/icons/dashboard-circle.png'

// const { Step } = Steps;




// const DashboardCalculations = () => {

//   const [open, setOpen] = useState(false);

//   const handleProjectClick = () => {
//     setOpen(true); // Open the modal when a project is clicked
//   };

//   const handleModalClose = () => {
//     setOpen(false); // Close the modal
//   };
//   const dummyData = [

//     {
//       key: '1',
//       view: 'with BBS',
//       project_code: 'PC001',
//       project_name: 'Project One',
//       status: 'Active',
//     },
//     {
//       key: '2',
//       view: 'without BBS',
//       project_code: 'PC002',
//       project_name: 'Project Two',
//       status: 'Inactive',
//     },

//   ];

//   // Columns for the table
//   const columns2 = [
//     {
//       title: "",
//       key: "view",
//       dataIndex: 'view',
//       //width: '160px',
//       //ellipsis: true,
//       render: (text) => (
//         <span
//           style={{
//             color: '#667085',
//             fontFamily: "'SF Pro Text', sans-serif",
//             fontWeight: '500',
//             fontSize: '12px',
//           }}
//         >
//           {text}
//         </span>
//       ),


//     },
//     {
//       title: (
//         <span
//           style={{
//             color: '#667085',
//             fontFamily: "'SF Pro Text', sans-serif",
//             fontWeight: '500',
//             fontSize: '11px',
//           }}
//         >
//           Projects
//         </span>
//       ),
//       dataIndex: 'bbs_id',
//       key: 'bbs_id',
//       //width: '160px',
//       //ellipsis: true,
//       render: (text) => (
//         <span
//           style={{
//             color: '#667085',
//             fontFamily: "'SF Pro Text', sans-serif",
//             fontWeight: '500',
//             fontSize: '11px',
//           }}
//         >
//           {text || 'N/A'}
//         </span>
//       ),
//       //sorter: (a, b) => a?.required_weight?.localeCompare(b?.required_weight),
//       //responsive: ['xl', 'xs', 'sm', 'xxl', 'md']
//     },
//     {
//       title: (
//         <span
//           style={{
//             marginLeft: '7px',
//             color: '#667085',
//             fontFamily: "'SF Pro Text', sans-serif",
//             fontWeight: '500',
//             fontSize: '11px',
//             display: 'flex',
//             alignItems: 'center',
//           }}
//         >
//           Tonnage
//         </span>
//       ),
//       dataIndex: 'Project', // The array in bbsList
//       key: 'project_code',
//       //width: '160px',
//       //ellipsis: true,
//       render: (text) => (
//         <span
//           style={{
//             color: '#667085',
//             fontFamily: "'SF Pro Text', sans-serif",
//             fontWeight: '500',
//             fontSize: '11px',
//           }}
//         >
//           {text || 'N/A'}
//         </span>
//       ),
//     },
//     {
//       title: (
//         <span
//           style={{
//             color: '#667085',
//             fontFamily: "'SF Pro Text', sans-serif",
//             fontWeight: '500',
//             fontSize: '11px',
//             display: 'flex',
//             alignItems: 'center',
//           }}
//         >
//           Wastage
//         </span>
//       ),
//       dataIndex: 'Project',
//       key: 'project_name',
//       // width: '160px',
//       //ellipsis: true,
//       render: (project) => (
//         <span
//           style={{
//             color: '#667085',
//             fontFamily: "'SF Pro Text', sans-serif",
//             fontWeight: '500',
//             fontSize: '11px',
//           }}
//         >
//           {project?.project_name || 'N/A'}
//         </span>
//       ),
//     },
//   ];


//   const columns1 = [
//     {
//       title: '',
//       key: 'label',
//       dataIndex: 'label',
//       render: (text, record) => (
//         <div
//           className="table-icons"
//         >
//           <span>{record.label}</span>
//         </div>
//       ),
//       width: '120px',
//       ellipsis: true, // Adjust column width as needed
//       //responsive: ['xl', 'lg', 'md', 'sm', 'xs'], // Optional: make it responsive
//     },
//     {
//       title: (
//         <span
//           style={{
//             color: '#667085',
//             fontFamily: "'SF Pro Text', sans-serif",
//             fontWeight: '500',
//             fontSize: '12px',
//           }}
//         >
//           Total Projects
//         </span>
//       ),
//       dataIndex: 'Location',
//       key: 'location',
//       width: '160px',
//       ellipsis: true,
//       render: (location) => (
//         <span
//           style={{
//             color: '#667085',
//             fontFamily: "'SF Pro Text', sans-serif",
//             fontWeight: '500',
//             fontSize: '12px',
//           }}
//         >
//           {location?.name || 'N/A'}
//         </span>
//       ),
//     },
//     {
//       title: (
//         <span
//           style={{
//             color: '#667085',
//             fontFamily: "'SF Pro Text', sans-serif",
//             fontWeight: '500',
//             fontSize: '12px',
//           }}
//         >
//           Total Tonnage
//         </span>
//       ),
//       dataIndex: 'Location',
//       key: 'location',
//       width: '160px',
//       ellipsis: true,
//       render: (location) => (
//         <span
//           style={{
//             color: '#667085',
//             fontFamily: "'SF Pro Text', sans-serif",
//             fontWeight: '500',
//             fontSize: '12px',
//           }}
//         >
//           {location?.name || 'N/A'}
//         </span>
//       ),
//     },
//     {
//       title: (
//         <span
//           style={{
//             color: '#667085',
//             fontFamily: "'SF Pro Text', sans-serif",
//             fontWeight: '500',
//             fontSize: '12px',
//           }}
//         >
//           Total Wastage
//         </span>
//       ),
//       dataIndex: 'Location',
//       key: 'location',
//       width: '160px',
//       ellipsis: true,
//       render: (location) => (
//         <span
//           style={{
//             color: '#667085',
//             fontFamily: "'SF Pro Text', sans-serif",
//             fontWeight: '500',
//             fontSize: '12px',
//           }}
//         >
//           {location?.name || 'N/A'}
//         </span>
//       ),
//     },
//     {
//       title: "",
//       key: "view",
//       width: '160px',
//       ellipsis: true,
//       render: () => (
//         <Button onClick={handleProjectClick} type="link" icon={<EyeOutlined />}
//         />
//       ),
//     },
//   ];

//   const data1 = [
//     {
//       key: 1,
//       name: "John Brown sr.",
//       age: 60,
//       address: "New York No. 1 Lake Park",
//       children: [
//         {
//           key: 2,
//           name: "Jim Green sr.",
//           age: 72,
//           address: "London No. 1 Lake Park",
//           children: [
//             {
//               key: 3,
//               name: "Jim Green",
//               age: 42,
//               address: "London No. 2 Lake Park",
//               children: [
//                 {
//                   key: 4,
//                   name: "Jim Green jr.",
//                   age: 25,
//                   address: "London No. 3 Lake Park",
//                 },
//                 {
//                   key: 5,
//                   name: "Jimmy Green sr.",
//                   age: 18,
//                   address: "London No. 4 Lake Park",
//                 },
//               ],
//             },
//           ],
//         },
//       ],
//     },

//   ];



//   const [expandedKeys, setExpandedKeys] = useState([]);

//   const data = [
//     {
//       key: "1",
//       label: "SBG",
//       totalProjects: 120,
//       totalTonnage: "60,000",
//       totalWastage: "8%",
//       children: [
//         {
//           key: "1-1",
//           label: "SBU",
//           totalProjects: 100,
//           totalTonnage: "70,000",
//           totalWastage: "10%",
//           children: [
//             {
//               key: "1-1-1",
//               label: "BU",
//               totalProjects: 70,
//               totalTonnage: "50,000",
//               totalWastage: "5%",
//               children: [
//                 {
//                   key: "1-1-1-1",
//                   label: "P1",
//                   totalProjects: 80,
//                   totalTonnage: "68,000",
//                   totalWastage: "2%",
//                 },
//                 {
//                   key: "1-1-1-2",
//                   label: "P2",
//                   totalProjects: 90,
//                   totalTonnage: "55,000",
//                   totalWastage: "6%",
//                 },
//               ],
//             },
//           ],
//         },
//       ],
//     },
//   ];

//   // Handle row expansion
//   const handleExpand = (expanded, record) => {
//     setExpandedKeys((prev) => {
//       if (expanded) {
//         return [...prev, record.key];
//       } else {
//         return prev.filter((key) => key !== record.key);
//       }
//     });
//   };

//   //Columns for the table
//   // const columns1 = [
//   //   {
//   //     title: "Item",
//   //     dataIndex: "label",
//   //     key: "label",
//   //     render: (text, record) => (
//   //       <span>
//   //         {record.children && expandedKeys.includes(record.key) ? (
//   //           <CaretDownOutlined style={{ marginRight: 8 }} />
//   //         ) : record.children ? (
//   //           <CaretRightOutlined style={{ marginRight: 8 }} />
//   //         ) : null}
//   //         {text}
//   //       </span>
//   //     ),
//   //   },
//   //   {
//   //     title: "Total Projects",
//   //     dataIndex: "totalProjects",
//   //     key: "totalProjects",
//   //   },
//   //   {
//   //     title: "Total Tonnage",
//   //     dataIndex: "totalTonnage",
//   //     key: "totalTonnage",
//   //   },
//   //   {
//   //     title: "Total Wastage",
//   //     dataIndex: "totalWastage",
//   //     key: "totalWastage",
//   //   },
//   //   {
//   //     title: "",
//   //     key: "view",
//   //     render: () => (
//   //       <Button type="link" icon={<EyeOutlined />} />
//   //     ),
//   //   },
//   // ];




//   const [expandedRows, setExpandedRows] = useState([]); // Keeps track of expanded rows

//   const toggleRow = (level) => {
//     setExpandedRows((prev) =>
//       prev.includes(level)
//         ? prev.filter((item) => item !== level) // Collapse
//         : [...prev, level] // Expand
//     );
//   };

//   const tableData = [
//     {
//       level: 1,
//       label: "SBG",
//       totalProjects: 120,
//       totalTonnage: "60,000",
//       totalWastage: "8%",
//       children: [
//         {
//           level: 2,
//           label: "SBU",
//           totalProjects: 100,
//           totalTonnage: "70,000",
//           totalWastage: "10%",
//           children: [
//             {
//               level: 3,
//               label: "BU",
//               totalProjects: 70,
//               totalTonnage: "50,000",
//               totalWastage: "5%",
//               children: [
//                 {
//                   level: 4,
//                   label: "P1",
//                   totalProjects: 80,
//                   totalTonnage: "68,000",
//                   totalWastage: "2%",
//                 },
//                 {
//                   level: 4,
//                   label: "P2",
//                   totalProjects: 90,
//                   totalTonnage: "55,000",
//                   totalWastage: "6%",
//                 },
//               ],
//             },
//           ],
//         },
//       ],
//     },
//   ];

//   const renderRow = (row, level = 1) => {
//     const isExpanded = expandedRows.includes(row.label);

//     return (
//       <React.Fragment key={row.label}>
//         <tr className={`level-${level}`}>
//           <td>
//             <div className="item">
//               {row.children && (
//                 <span
//                   className="toggle-icon"
//                   onClick={() => toggleRow(row.label)}
//                 >
//                   {isExpanded ? "▼" : "▶"}
//                 </span>
//               )}
//               <span>{row.label}</span>
//             </div>
//           </td>
//           <td>{row.totalProjects}</td>
//           <td>{row.totalTonnage}</td>
//           <td>{row.totalWastage}</td>
//           <td>
//             <button className="view-button">👁</button>
//           </td>
//         </tr>
//         {isExpanded &&
//           row.children &&
//           row.children.map((child) => renderRow(child, level + 1))}
//       </React.Fragment>
//     );
//   };



//   const [expandedRowKeys, setExpandedRowsKeys] = useState([]);
//   const [isModalVisible, setIsModalVisible] = useState(false);
  //  const [isBackdropBlurred, setIsBackdropBlurred] = useState(false);

//   const dataSource = [
//     {
//       key: "1",
//       projectCode: "PA123",
//       existingBBS: ["BBS001", "BBS002", "BBS003"],
//     },
//     {
//       key: "2",
//       projectCode: "PB456",
//       existingBBS: ["BBS004", "BBS005"],
//     },
//     {
//       key: "3",
//       projectCode: "PC789",
//       existingBBS: ["BBS006"],
//     },
//   ];

//   const columns = [
//     {
//       title: (
//         <span
//           style={{
//             marginLeft: '7px',
//             color: '#667085',
//             fontFamily: "'SF Pro Text', sans-serif",
//             fontWeight: '500',
//             fontSize: '12px',
//             display: 'flex',
//             alignItems: 'center',
//           }}
//         >
//           Project Name and Project Code
//           <img
//             src={arrow_down}
//             alt="icon"
//             style={{ marginLeft: '5px', width: '16px', height: '16px' }}
//           />
//         </span>
//       ),
//       dataIndex: 'Project', // The array in bbsList
//       key: 'projectCode',
//       ellipsis: true,
//       render: (_, record) => (
//         <div>
//           <a
//             href={`/projects/${record.projectCode}`}
//             style={{ color: "#1890ff", textDecoration: "underline", marginLeft: '7px' }}
//           >
//             {record.projectCode}
//           </a>
//         </div>
//       ),
//     },
//     {
//       title: (
//         <span
//           style={{

//             color: '#667085',
//             fontFamily: "'SF Pro Text', sans-serif",
//             fontWeight: '500',
//             fontSize: '12px',
//             display: 'flex',
//             alignItems: 'center',
//           }}
//         >
//           Existing BBS
//           <img
//             src={chevron_down}
//             alt="icon"
//             style={{ marginLeft: '5px', width: '16px', height: '16px' }}
//           />
//         </span>
//       ),
//       dataIndex: "existingBBS",
//       key: "existingBBS",

//       ellipsis: true,
//       render: (bbsList) => (
//         <div>
//           {bbsList.map((bbs, index) => (
//             <div key={index}>
//               <a
//                 href="#"
//                 onClick={(e) => {
//                   e.preventDefault();
//                   setIsModalVisible(true);
//                   setIsBackdropBlurred(true);
//                 }}
//                 style={{ color: "#1890ff", textDecoration: "underline" }}
//               >
//                 {bbs}
//               </a>
//             </div>
//           ))}
//         </div>
//       ),
//     },
//     {
//       title: "", // No header for this column
//       key: "action",
//       render: () => (
//         <Button type="primary" style={{
//           backgroundColor: "#1C4E9D", borderRadius: '8px', text: '#FFFFFF', fontSize: '12px',
//           padding: '8px 16px',
//         }}>
//           Create BBS
//         </Button>
//       ),
//     },
//   ];


//   const handleCancel = () => {
//     setIsModalVisible(false);
//     setIsBackdropBlurred(false);
//   };

//   const handleConfirm = () => {
//     setIsModalVisible(false);
//     setIsBackdropBlurred(false);
//     // Add your download logic here
//     console.log("Download Confirmed");
//   };



//   const getAllKeys = (data) => {
//     return (
//       (data?.flatMap((record) => [
//         record.key,
//         ...(record.children ? getAllKeys(record.children) : []),
//       ]) || [])
//     );
//   };

//   const [isOpen, setIsOpen] = useState(false);

//   const toggleDropdown = () => {
//     setIsOpen(!isOpen);
//   };


//   return (
//     <div className="main-div">
//       <div className="flex justify-between items-center">
//         <div className='ml-6 mt-3'>
//           <p className="text-[#1C4E9D] font-['SF-Pro-Text-Regular, sans-serif'] md:text-[20px] font-semibold text-[10px]">As per, the selected quarter</p>
//         </div>
//         <div className="flex gap-2 mt-4 mr-8">
//           {/* <button className="bg-[#1C4E9D] px-0 py-0 rounded-[8px] md:w-[76px] w-auto md:h-[30px] h-auto text-[#FFFFFF] font-['SF-Pro-Text-Regular, sans-serif'] text-[14px]">
//             ITD
//           </button>
//           <button className="bg-[#FFFFFF] px-0 py-0 rounded-[8px] md:w-[103px] w-auto md:h-[30px] h-auto text-[#344054] font-['SF-Pro-Text-Regular, sans-serif'] text-[14px] border border-[#D0D5DD]">
//             Last 3 Months
//           </button>
//           <button className="bg-[#FFFFFF] px-0 py-0 rounded-[8px] md:w-[103px] w-auto md:h-[30px] h-auto text-[#344054] font-['SF-Pro-Text-Regular, sans-serif'] text-[14px] border border-[#D0D5DD]">
//             Last Month
//           </button> */}
//           <div>
//             {/* Button */}
//             <button
//               className="flex bg-[#FFFFFF] md:w-[249px] gap-2 justify-center items-center w-auto text-[#344054] font-['SF-Pro-Text-Regular, sans-serif'] text-[12px] rounded-[8px]"
//               onClick={toggleDropdown}
//             >
//               FY24-25 (1-Oct - 24 to 31-Dec-24)
//               <img
//                 src={filterIcon}
//                 alt="Filter Icon"
//                 className="cursor-pointer"
//                 onClick={(e) => {
//                   e.stopPropagation(); // Prevents the button click
//                   toggleDropdown();
//                 }}
//               />
//             </button>

//             {/* Full-Screen Overlay */}
//             {isOpen && (
//               <div className="fixed inset-0 z-10 flex justify-end">
//                 {/* Content Panel */}
//                 <div className="w-[515px] h-full bg-[#F3F8FF] shadow-lg border-l border-gray-300">
//                   <div className="p-4">
//                     <p className="text-[#344054] p-1 font-['SF-Pro-Text-Regular, sans-serif'] text-[12px] mb-4 bg-[#E6F0FF] rounded-[8px] w-[225px]">
//                       Filter Options
//                     </p>
//                     <Card style={{borderColor:'#E1E1E1'}}>
//                     <div className="flex flex-col space-y-4 mt-[-15px] mb-[-15px] ml-[-12px]">
//                       <label className="flex items-center gap-2 ">
//                         <input type="checkbox" className="form-checkbox" />
//                         FY20 - 21
//                       </label>
//                       <label className="flex items-center gap-2">
//                         <input type="checkbox" className="form-checkbox" />
//                         FY21 - 22
//                       </label>
//                       <label className="flex items-center gap-2">
//                         <input type="checkbox" className="form-checkbox" />
//                         FY22 - 23
//                       </label>
//                       <label className="flex items-center gap-2">
//                         <input type="checkbox" className="form-checkbox" />
//                         FY23 - 24
//                       </label>
//                       <label className="flex items-center gap-2">
//                         <input type="checkbox" className="form-checkbox" />
//                         FY24 - 25
//                       </label>
//                     </div>
//                     </Card>
//                     <div className="mt-4 flex gap-4 justify-center">
//                       <button
//                         className="bg-[#FFFFFF] text-[#344054] border border-gray-300 rounded-[8px] px-4 py-2"
//                         onClick={() => setIsOpen(false)} // Close when clicking "Clear"
//                       >
//                         Clear
//                       </button>
//                       <button
//                         className="bg-[#1C4E9D] text-[#FFFFFF] rounded-[8px] px-4 py-2"
//                         onClick={() => setIsOpen(false)} // Close when clicking "Next"
//                       >
//                         Next
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>

//       {/* 
//       <div className="card-container flex justify-between gap-5 p-5">
//         <div className="big-card flex-1 w-[300px] p-5 rounded-lg bg-gradient-to-b from-[#F1F1F1] to-[#C7DCFF]">
//           <CircularProgressBar
//             mainTitle="Total"
//             subTitle="Projects"
//             segments={[
//               { label: 'Projects', percentage: 30, color: '#1C4E9D' },
//               { label: 'Tonnage', percentage: 30, color: '#12B76A' },
//               { label: 'Wastage', percentage: 40, color: '#667085' },
//             ]}
//           />

//         </div>
//         <div className="big-card flex-1 w-[300px] p-5 rounded-lg bg-gradient-to-b from-[#F1F1F1] to-[#C7DCFF]">

//           <CircularProgressBar
//             mainTitle="With"
//             subTitle="BBS"
//             segments={[
//               { label: 'Projects', percentage: 40, color: '#1C4E9D' },
//               { label: 'Tonnage', percentage: 35, color: '#12B76A' },
//               { label: 'Wastage', percentage: 25, color: '#667085' },
//             ]}
//           />
//         </div>
//         <div className="big-card flex-1 w-[300px] p-5 rounded-lg bg-gradient-to-b from-[#F1F1F1] to-[#C7DCFF]">
//           <CircularProgressBar
//             mainTitle="Without"
//             subTitle="BBS"
//             segments={[
//               { label: 'Projects', percentage: 50, color: '#1C4E9D' },
//               { label: 'Tonnage', percentage: 30, color: '#12B76A' },
//               { label: 'Wastage', percentage: 20, color: '#667085' },
//             ]}
//           />
//         </div>
//       </div> */}





//       <Space direction="vertical" size="small" style={{ display: "flex" }}>






//         <div style={{ padding: "20px" }}>


//           <div className="bg-[#FFFFFF] p-5 rounded-md shadow-md mb-10">
//             {/* Top Info Section */}
//             <div className="flex justify-center items-center gap-2 ">
//               <img className="w-[14px] h-[14px]" src={dashboardCircle} alt="Info Icon" />
//               <p className="text-[#99A3AF] font-['SF-Pro-Text-Regular, sans-serif'] text-[12px]">
//                 Projects includes System generated wastage BBS, Actual wastage BBS, Wastage without BBS - in the selected quarter
//               </p>
//             </div>

//             {/* Main Content Section */}
//             <div className="flex flex-col justify-around items-center md:flex md:flex-row">
//               {/* First Section */}
//               <div className="w-[344px] flex flex-col items-center text-center">
//                 <p className="text-[#1C4E9D] font-bold text-[28px]">350</p>
//                 <p className="text-[#818181] text-[16px]">Total Projects</p>
//               </div>

//               {/* Vertical Divider */}
//               <div className="mt-5 md:h-[75px] md:w-[1px] md:bg-[#E0E0E0] hidden md:inline"></div>

//               {/* Second Section */}
//               <div className="w-[344px] flex flex-col items-center text-center">
//                 <p className="text-[#6FCB29] font-bold text-[28px]">
//                   300
//                   <span className="text-[11px] font-normal text-[#818181] ml-1 align-middle hidden md:inline">Projects with</span>
//                 </p>
//                 <p className="text-[#818181] text-[16px]">Complete Wastage Information</p>
//               </div>

//               {/* Vertical Divider */}
//               <div className="mt-5 md:h-[75px] md:w-[1px] md:bg-[#E0E0E0] hidden md:inline"></div>

//               {/* Third Section */}
//               <div className="w-[344px] flex flex-col items-center text-center">
//                 <p className="text-[#B64439] font-bold text-[28px]">
//                   50
//                   <span className="text-[11px] font-normal text-[#818181] ml-1 align-middle hidden md:inline">Projects with</span>
//                 </p>
//                 <p className="text-[#818181] text-[16px]">Incomplete Wastage Information</p>
//               </div>
//             </div>
//           </div>



//           <Table
//             className="dashboardtwotable"
            
//             columns={columns1}
//             dataSource={data}
//             scroll={{ x: 'max-content' }}
//             pagination={false}
//           // expandable={{
//           //   onExpand: (expanded, record) => {
//           //     expanded
//           //       ? setExpandedRowsKeys([...expandedRowKeys, record.key])
//           //       : setExpandedRowsKeys(expandedRowKeys.filter((key) => key !== record.key));
//           //   },
//           //   expandedRowKeys: expandedRowKeys,
//           //   expandIcon: ({ expanded, onExpand, record }) =>
//           //     record.children && record.children.length > 0 ? (
//           //       <div
//           //         style={{
//           //           display: 'inline-flex',
//           //           flexDirection: 'row',
//           //           alignItems: 'center',
//           //           justifyContent: 'start',
//           //           gap: '5px',
//           //         }}
//           //         onClick={(e) => {
//           //           e.stopPropagation();
//           //           onExpand(record, e);
//           //         }}
//           //       >
//           //         {expanded ? (
//           //           <img
//           //             src={dashboard_table_icon}
//           //             alt="Collapse"
//           //             style={{
//           //               cursor: 'pointer',
//           //               width: '16px',
//           //               height: '16px',
//           //             }}
//           //           />
//           //         ) : (
//           //           <img
//           //             src={dashboard_down_icon}
//           //             alt="Expand"
//           //             style={{
//           //               cursor: 'pointer',
//           //               width: '16px',
//           //               height: '16px',
//           //             }}
//           //           />
//           //         )}
//           //         <span>{record.label}</span>
//           //       </div>
//           //     ) : null,
//           // }}
//           />

//           <Modal
//             title={
//               <div
//                 style={{
//                   fontFamily: "'SF Pro Text', sans-serif",
//                   fontSize: '16px',
//                   fontWeight: 600,
//                   marginBottom: '20px',
//                   color: '#1C4E9D',
//                 }}
//               >
//                 SBG
//               </div>
//             }
//             centered
//             open={open}
//             onCancel={handleModalClose} // Close the modal on Cancel click
//             width={445}
//             height={217}
//             footer={null}
//           >
//             <Table
//               dataSource={dummyData} // Pass the dummy data to the table
//               columns={columns2} // Pass the columns for the table
//               bordered
//               pagination={false}
//               scroll={{ x: 'max-content' }}
//               className="responsive-table" /* {{ total: dummyData.length }}*/
//             />
//           </Modal>


//           <div style={{ display: "flex", flexDirection: "column", alignItems: "stretch", marginTop: '40px' }}>
//             <Table
//               dataSource={dataSource}
//               columns={columns}
//               pagination={false}
//               style={{ width: "100%" }}
//               scroll={{ x: "max-content" }}
//             />

//             <Modal
//               visible={isModalVisible}
//               onOk={handleConfirm}
//               onCancel={handleCancel}
//               footer={[
//                 <Button className="rounded-lg text-[14px] font-['SF-Pro-Text-Regular, sans-serif'] text-[#344054] md:w-[170px] w-auto" key="cancel" onClick={handleCancel}>
//                   Cancel
//                 </Button>,
//                 <Button className=" bg-[#1C4E9D] rounded-lg text-[14px] font-['SF-Pro-Text-Regular, sans-serif'] text-[#FFFFFF] md:w-[170px] w-auto" key="download" type='primary' onClick={handleConfirm}>
//                   Download
//                 </Button>

//               ]}
//               style={{ zIndex: 1050, height: '93px' }}
//               title={null} // Remove default title
//               // Add padding to the body content
//               width={400}

//             >
//               <div style={{ display: "flex", flexDirection: "column", alignItems: "start" }}>
//                 <img
//                   src={download_pop_icon}
//                   alt="Download Icon"
//                   style={{ width: "48px", height: "48px", marginBottom: "10px" }} // Add marginBottom for spacing
//                 />
//                 <p className="text-start text-[13px] text-[#344054] font-['SF-Pro-Text-Regular, sans-serif']">
//                   Are you sure you want to download the final BBS summary?
//                 </p>
//               </div>
//             </Modal>

//             <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "10px" }}>
//               <Button className="bg-[#1C4E9D] rounded-lg text-[14px] font-['SF-Pro-Text-Regular, sans-serif'] " type="primary">Get approval for a project</Button>
//             </div>
//           </div>

//           {/* <Table
//         dataSource={data}
//         columns={columns1}
//         expandable={{
//           expandedRowKeys: expandedKeys,
//           onExpand: handleExpand,
//         }}
//         pagination={false}
//         bordered={false}
//       /> */}
//         </div>

//       </Space>








//     </div>
//   )

// };

// export default DashboardCalculations;



// THIS CODE BELOW IS FOR EXPERIMENT PURPOSE PLEASE DONT DELETE THE ABOVE CODE:

//this code is when the project is rejected so automatically the user also gets rejected:
// import React from 'react';
// import { useState, useEffect } from 'react';
// import './style.css';
// import { useNavigate } from 'react-router-dom';
// import {
//   Card,
//   Form,
//   Input,
//   Button,
//   Row,
//   Col,
//   Steps,
//   Upload,
//   message,
//   Select,
//   Space,
//   Modal,
// } from 'antd';
// import DashboardTable from '../dashboardTable/index.js';
// import step_base_icon from '../../../../assets/icons/step_base_icon.png';
// import dangerIcon from '../../../../assets/icons/danger_icon.png';
// import {
//   getProjectList,
//   createBbs,
//   getBbsList,
// } from '../../redux/slice.js';
// import { useSelector, useDispatch } from 'react-redux';
// import { TextArea } from 'semantic-ui-react';

// const { Step } = Steps;

// const CreateBBSPage = ({ onReturnToDashboard }) => {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const { Option } = Select;

//   const [form] = Form.useForm();
//   const [formData, setFormData] = useState({});

//   const [currentStep, setCurrentStep] = useState(0);

//   const [isStepperFormVisible, setIsStepperFormVisible] = useState(false);
//      const [isModalVisible, setIsModalVisible] = useState(false);
//         const [isBackdropBlurred, setIsBackdropBlurred] = useState(false);
//         const [isRejectionModalVisible, setRejectionModalVisible] = useState(false);

//         // Handle modal visibility
//         const showRejectionModal = () => {
//           setRejectionModalVisible(true);
//         };
      
//         const handleRejectionConfirm = () => {
//           // Handle the rejection logic here
//           console.log("Rejected!");
//           setRejectionModalVisible(false); // Close modal
//         };
      
//         const handleRejectionCancel = () => {
//           setRejectionModalVisible(false); // Close modal
//         };

  


//   const nextStep = () => {
//     form
//       .validateFields()
//       .then((values) => {
//         const payload = {
//           project_id: Number(values?.project_id),
//           sbg_id: values?.sbg_id,
//           //location_id: values?.location_id,
//           sbu_id: values?.sbu_id,
//         };
//         console.log('Payload:', payload);
//         dispatch(createBbs(payload))
//           .then((response) => {
//             if (response?.payload?.success) {
//               message.success(response?.payload?.message);
//             } else {
//               message.error(response?.payload?.message);
//             }
//             setFormData((prevData) => {
//               const updatedData = { ...prevData, ...values };
//               console.log('Updated data:', updatedData);
//               return updatedData;
//             });

//             setIsStepperFormVisible(false);
//             if (onReturnToDashboard) {
//               onReturnToDashboard();
//             }
//           })
//           .catch((error) => {
//             console.error('API call failed:', error);
//             message.error('Failed to submit the form.');
//           });
//       })
//       .catch((info) => {
//         console.log('Validation failed:', info);
//       });
//   };

//   useEffect(() => {
//     console.log('Form data updated:', formData);
//   }, [formData]);

//   const clearform = () => {
//     form.resetFields();
//   };

//   const [stepStyle, setStepStyle] = useState({ width: 'auto' });

//   useEffect(() => {
//     const handleResize = () => {
//       const width = window.innerWidth;

//       if (width < 575) {
//         setStepStyle({ width: 'auto' });
//       } else if (width < 768) {
//         setStepStyle({ width: '100%' });
//       } else {
//         setStepStyle({ width: 'auto' });
//       }
//     };

//     handleResize();

//     window.addEventListener('resize', handleResize);

//     return () => window.removeEventListener('resize', handleResize);
//   }, []);

//   const steps = [
//     {
//       title: <div className="step-title">Project Details</div>,
//       content: (
//         <Form form={form} layout="vertical">
//           <Row gutter={24}>
//             <Col span={12} xs={24} sm={12}>
//               <Form.Item label="Project Code" name="project_id">
//                 <Input placeholder='enter project code'/>
//               </Form.Item>
//             </Col>
//             <Col span={12} xs={24} sm={12}>
//               <Form.Item
//                 label="Project Name"
//                 name="project_name"
//                 rules={[{ required: true, message: 'Please select a project' }]}
//               >
//                 <Input placeholder='enter project name'/>
//               </Form.Item>
//             </Col>
//             <Col span={12} xs={24} sm={12}>
//               <Form.Item
//                 label="BU"
//                 name="bu"
//                 rules={[{ message: 'Please enter the project name' }]}
//               >
//                 <Input placeholder='select bu'/>
//               </Form.Item>
//             </Col>
//             <Col span={12} xs={24} sm={12}>
//               <Form.Item
//                 label="SBU"
//                 name="sbu_id"
//                 //rules={[{ message: "Please enter the project code" }]}
//               >
//                 <Input placeholder='enter sbu'/>
//               </Form.Item>
//             </Col>
//             <Col span={12} xs={24} sm={12}>
//               <Form.Item
//                 label="SBG"
//                 name="sbg_id"
//                 //rules={[{ message: "Please enter the project code" }]}
//               >
//                 <Input placeholder='enter sbg'/>
//               </Form.Item>
//             </Col>
//             <Col span={12} xs={24} sm={12}>
//               <Form.Item
//                 label="Total Quantity of Project"
//                 name="sbg_id"
//                 //rules={[{ message: "Please enter the project code" }]}
//               >
//                 <Input placeholder='enter total quantity of project'/>
//               </Form.Item>
//             </Col>
//             <Col span={12} xs={24} sm={12}>
//               <Form.Item
//                 label="Wastage Percentage Considered"
//                 name="sbg_id"
//                 //rules={[{ message: "Please enter the project code" }]}
//               >
//                 <Input placeholder='enter wastage'/>
//               </Form.Item>
//             </Col>
//             <Col span={12} xs={24} sm={12}>
//               <Form.Item
//                 label="Role of the BBS User"
//                 name="bu"
//                 rules={[{ message: 'Please enter the project name' }]}
//               >
//                 <Select
//                   placeholder="select role of the BBS user"
//                   className="custom-select"
//                 >
//                   <Select.Option value="project1">Project 1</Select.Option>
//                   <Select.Option value="project2">Project 2</Select.Option>
//                   <Select.Option value="project3">Project 3</Select.Option>
//                 </Select>
//               </Form.Item>
//             </Col>


//           </Row>
//         </Form>
//       ),
//     },
//   ];
//   return (
//     <div className="main-div">
//       <div className="steps_parent_bbs">
//         <Steps
//           className="steps_track_bbs"
//           style={stepStyle}
//           current={currentStep}
//           labelPlacement="vertical"
//         >
//           {steps.map((item, index) => (
//             <Step
//               key={index}
//               icon={
//                 <img
//                   src={step_base_icon}
//                   alt="Step Icon"
//                   className="step-icon"
//                 />
//               }
//               title={
//                 <div className="step-title-container flex flex-col">
//                   <div className="step-title text-blue-800 font-semibold text-sm">
//                     {item.title}
//                   </div>
//                 </div>
//               }
//             />
//           ))}
//         </Steps>
//       </div>

//       <div className="step-card flex justify-center items-center">
//         <div className="steps_content_parent ">
//           <Card>
//             <div className="steps-content">
//               {steps[currentStep] ? (
//                 steps[currentStep].content
//               ) : (
//                 <div>No content available</div>
//               )}
//             </div>
//             <div className="steps-action text-center mt-4">
//               {currentStep === 0 && (
//                 <>
//                    <Button
//         style={{ margin: "0 8px" }}
//         onClick={showRejectionModal}
//         className="bg-[#F43E3E] text-[#FFFFFF] rounded-lg px-4 py-2"
//       >
//         Reject
//       </Button>

//       {/* Rejection Modal */}
//       <Modal
//         visible={isRejectionModalVisible}
//         onOk={handleRejectionConfirm}
//         onCancel={handleRejectionCancel}
//         footer={[
//           <Button
//             className="rounded-lg text-[14px] font-['SF-Pro-Text-Regular, sans-serif'] text-[#344054] md:w-[170px] w-auto"
//             key="cancel"
//             onClick={handleRejectionCancel}
//           >
//             Cancel
//           </Button>,
//           <Button
//             className="bg-[#F43E3E] rounded-lg text-[14px] font-['SF-Pro-Text-Regular, sans-serif'] text-[#FFFFFF] md:w-[170px] w-auto"
//             key="reject"
//             type="primary"
//             onClick={handleRejectionConfirm}
//           >
//              Reject
//           </Button>,
//         ]}
//         style={{ zIndex: 1050 }}
//         title={
//           <div style={{ display: "flex", alignItems: "center" }}>
//             <img
//               src={dangerIcon}
//               alt="Danger Icon"
//               style={{ width: "48px", height: "48px", marginRight: "8px" }}
//             />
//           </div>
//         }
//         width={400}
//       >
//         <div style={{ display: "flex", flexDirection: "column", alignItems: "start" }}>
//           <p className="text-start text-[13px] text-[#344054] font-['SF-Pro-Text-Regular, sans-serif']">
//             Rejection
//           </p>
//           <TextArea className='w-[352px] border-[#D0D5DD] border-[1px]'></TextArea>
//         </div>
//       </Modal>
//                   <Button
//                     type="primary"
//                     //onClick={nextStep}
//                     className=" bg-[#12B76A] text-[#FFFFFF] rounded-lg"
//                   >
//                     Approve
//                   </Button>
//                 </>
//               )}
//             </div>
//           </Card>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CreateBBSPage;






//This code is when the user and project both gets approved:

import React from 'react';
import { useState, useEffect } from 'react';
import './style.css';
import { useNavigate } from 'react-router-dom';
import {
  Card,
  Form,
  Input,
  Button,
  Row,
  Col,
  Steps,
  Upload,
  message,
  Select,
  Space,
  Modal,
} from 'antd';
import DashboardTable from '../dashboardTable/index.js';
import step_base_icon from '../../../../assets/icons/step_base_icon.png';
import dangerIcon from '../../../../assets/icons/danger_icon.png';
import {
  getProjectList,
  createBbs,
  getBbsList,
} from '../../redux/slice.js';
import { useSelector, useDispatch } from 'react-redux';
import { TextArea } from 'semantic-ui-react';

const { Step } = Steps;

const CreateBBSPage = ({ onReturnToDashboard }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { Option } = Select;

  const [form] = Form.useForm();
  const [formData, setFormData] = useState({});

  const [currentStep, setCurrentStep] = useState(0);

  const [isStepperFormVisible, setIsStepperFormVisible] = useState(false);
     const [isModalVisible, setIsModalVisible] = useState(false);
        const [isBackdropBlurred, setIsBackdropBlurred] = useState(false);
        const [isRejectionModalVisible, setRejectionModalVisible] = useState(false);

        // Handle modal visibility
        const showRejectionModal = () => {
          setRejectionModalVisible(true);
        };
      
        const handleRejectionConfirm = () => {
          // Handle the rejection logic here
          console.log("Rejected!");
          setRejectionModalVisible(false); // Close modal
        };
      
        const handleRejectionCancel = () => {
          setRejectionModalVisible(false); // Close modal
        };

  


  const nextStep = () => {
    form
      .validateFields()
      .then((values) => {
        const payload = {
          project_id: Number(values?.project_id),
          sbg_id: values?.sbg_id,
          //location_id: values?.location_id,
          sbu_id: values?.sbu_id,
        };
        console.log('Payload:', payload);
        dispatch(createBbs(payload))
          .then((response) => {
            if (response?.payload?.success) {
              message.success(response?.payload?.message);
            } else {
              message.error(response?.payload?.message);
            }
            setFormData((prevData) => {
              const updatedData = { ...prevData, ...values };
              console.log('Updated data:', updatedData);
              return updatedData;
            });

            setIsStepperFormVisible(false);
            if (onReturnToDashboard) {
              onReturnToDashboard();
            }
          })
          .catch((error) => {
            console.error('API call failed:', error);
            message.error('Failed to submit the form.');
          });
      })
      .catch((info) => {
        console.log('Validation failed:', info);
      });
  };

  useEffect(() => {
    console.log('Form data updated:', formData);
  }, [formData]);

  const clearform = () => {
    form.resetFields();
  };

  const [stepStyle, setStepStyle] = useState({ width: 'auto' });

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;

      if (width < 575) {
        setStepStyle({ width: 'auto' });
      } else if (width < 768) {
        setStepStyle({ width: '100%' });
      } else {
        setStepStyle({ width: 'auto' });
      }
    };

    handleResize();

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const steps = [
    {
      title: <div className="step-title">Project Details</div>,
      content: (
        <Form form={form} layout="vertical">
          <Row gutter={24}>
            <Col span={12} xs={24} sm={12}>
              <Form.Item label="Project Code" name="project_id">
                <Input placeholder='enter project code'/>
              </Form.Item>
            </Col>
            <Col span={12} xs={24} sm={12}>
              <Form.Item
                label="Project Name"
                name="project_name"
                rules={[{ required: true, message: 'Please select a project' }]}
              >
                <Input placeholder='enter project name'/>
              </Form.Item>
            </Col>
            <Col span={12} xs={24} sm={12}>
              <Form.Item
                label="BU"
                name="bu"
                rules={[{ message: 'Please enter the project name' }]}
              >
                <Input placeholder='select bu'/>
              </Form.Item>
            </Col>
            <Col span={12} xs={24} sm={12}>
              <Form.Item
                label="SBU"
                name="sbu_id"
                //rules={[{ message: "Please enter the project code" }]}
              >
                <Input placeholder='enter sbu'/>
              </Form.Item>
            </Col>
            <Col span={12} xs={24} sm={12}>
              <Form.Item
                label="SBG"
                name="sbg_id"
                //rules={[{ message: "Please enter the project code" }]}
              >
                <Input placeholder='enter sbg'/>
              </Form.Item>
            </Col>
            <Col span={12} xs={24} sm={12}>
              <Form.Item
                label="Total Quantity of Project"
                name="sbg_id"
                //rules={[{ message: "Please enter the project code" }]}
              >
                <Input placeholder='enter total quantity of project'/>
              </Form.Item>
            </Col>
            <Col span={12} xs={24} sm={12}>
              <Form.Item
                label="Wastage Percentage Considered"
                name="sbg_id"
                //rules={[{ message: "Please enter the project code" }]}
              >
                <Input placeholder='enter wastage'/>
              </Form.Item>
            </Col>
            <Col span={12} xs={24} sm={12}>
              <Form.Item
                label="Role of the BBS User"
                name="bu"
                rules={[{ message: 'Please enter the project name' }]}
              >
                <Select
                  placeholder="select role of the BBS user"
                  className="custom-select"
                >
                  <Select.Option value="project1">Project 1</Select.Option>
                  <Select.Option value="project2">Project 2</Select.Option>
                  <Select.Option value="project3">Project 3</Select.Option>
                </Select>
              </Form.Item>
            </Col>


          </Row>
        </Form>
      ),
    },
    {
      title: <div className="step-title">User Details</div>,
      content: (
        <Form form={form} layout="vertical">
          <Row gutter={24}>
            <Col span={12} xs={24} sm={12}>
              <Form.Item label="Project Code" name="project_id">
                <Input placeholder='enter project code'/>
              </Form.Item>
            </Col>
            <Col span={12} xs={24} sm={12}>
              <Form.Item
                label="Project Name"
                name="project_name"
                rules={[{ required: true, message: 'Please select a project' }]}
              >
                <Input placeholder='enter project name'/>
              </Form.Item>
            </Col>
            <Col span={12} xs={24} sm={12}>
              <Form.Item
                label="BU"
                name="bu"
                rules={[{ message: 'Please enter the project name' }]}
              >
                <Input placeholder='select bu'/>
              </Form.Item>
            </Col>
            <Col span={12} xs={24} sm={12}>
              <Form.Item
                label="SBU"
                name="sbu_id"
                //rules={[{ message: "Please enter the project code" }]}
              >
                <Input placeholder='enter sbu'/>
              </Form.Item>
            </Col>
            <Col span={12} xs={24} sm={12}>
              <Form.Item
                label="SBG"
                name="sbg_id"
                //rules={[{ message: "Please enter the project code" }]}
              >
                <Input placeholder='enter sbg'/>
              </Form.Item>
            </Col>
            <Col span={12} xs={24} sm={12}>
              <Form.Item
                label="Total Quantity of Project"
                name="sbg_id"
                //rules={[{ message: "Please enter the project code" }]}
              >
                <Input placeholder='enter total quantity of project'/>
              </Form.Item>
            </Col>
            <Col span={12} xs={24} sm={12}>
              <Form.Item
                label="Wastage Percentage Considered"
                name="sbg_id"
                //rules={[{ message: "Please enter the project code" }]}
              >
                <Input placeholder='enter wastage'/>
              </Form.Item>
            </Col>
            <Col span={12} xs={24} sm={12}>
              <Form.Item
                label="Role of the BBS User"
                name="bu"
                rules={[{ message: 'Please enter the project name' }]}
              >
                <Select
                  placeholder="select role of the BBS user"
                  className="custom-select"
                >
                  <Select.Option value="project1">Project 1</Select.Option>
                  <Select.Option value="project2">Project 2</Select.Option>
                  <Select.Option value="project3">Project 3</Select.Option>
                </Select>
              </Form.Item>
            </Col>


          </Row>
        </Form>
      ),
    },
  ];
  return (
    <div className="main-div">
      <div className="steps_parent_bbs approver">
        <Steps
          className="steps_track_bbs manager"
          style={stepStyle}
          current={currentStep}
          labelPlacement="vertical"
        >
          {steps.map((item, index) => (
            <Step
            className='manager-icon'
              key={index}
              icon={
                <img
                  src={step_base_icon}
                  alt="Step Icon"
                  className="step-icon relative"
                />
              }
            
              title={
                <div className="step-title-container flex flex-col">
                  <div className="step-title text-blue-800 font-semibold text-sm">
                    {item.title}
                  </div>
                </div>
              }
            />
          ))}
        </Steps>
      </div>

      <div className="step-card flex justify-center items-center">
        <div className="steps_content_parent ">
          <Card>
            <div className="steps-content">
              {steps[currentStep] ? (
                steps[currentStep].content
              ) : (
                <div>No content available</div>
              )}
            </div>
            <div className="steps-action text-center mt-4">
              {currentStep === 0 && (
                <>
                   <Button
        style={{ margin: "0 8px" }}
        onClick={showRejectionModal}
        className="bg-[#F43E3E] text-[#FFFFFF] rounded-lg px-4 py-2"
      >
        Reject
      </Button>

      {/* Rejection Modal */}
      <Modal
        visible={isRejectionModalVisible}
        onOk={handleRejectionConfirm}
        onCancel={handleRejectionCancel}
        footer={[
          <Button
            className="rounded-lg text-[14px] font-['SF-Pro-Text-Regular, sans-serif'] text-[#344054] md:w-[170px] w-auto"
            key="cancel"
            onClick={handleRejectionCancel}
          >
            Cancel
          </Button>,
          <Button
            className="bg-[#F43E3E] rounded-lg text-[14px] font-['SF-Pro-Text-Regular, sans-serif'] text-[#FFFFFF] md:w-[170px] w-auto"
            key="reject"
            type="primary"
            onClick={handleRejectionConfirm}
          >
             Reject
          </Button>,
        ]}
        style={{ zIndex: 1050 }}
        title={
          <div style={{ display: "flex", alignItems: "center" }}>
            <img
              src={dangerIcon}
              alt="Danger Icon"
              style={{ width: "48px", height: "48px", marginRight: "8px" }}
            />
          </div>
        }
        width={400}
      >
        <div style={{ display: "flex", flexDirection: "column", alignItems: "start" }}>
          <p className="text-start text-[13px] text-[#344054] font-['SF-Pro-Text-Regular, sans-serif']">
            Rejection
          </p>
          <TextArea className='w-[352px] border-[#D0D5DD] border-[1px]'></TextArea>
        </div>
      </Modal>
                  <Button
                    type="primary"
                    //onClick={nextStep}
                    className=" bg-[#12B76A] text-[#FFFFFF] rounded-lg"
                  >
                    Approve
                  </Button>
                </>
              )}
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default CreateBBSPage;



